import { render, staticRenderFns } from "./FooterTerminos.vue?vue&type=template&id=bf568e9e&"
import script from "./FooterTerminos.vue?vue&type=script&lang=js&"
export * from "./FooterTerminos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports